import { Component, Input } from '@angular/core';

@Component({
  selector: 'nx-ng-bus-e-commerce-renderer',
  templateUrl: './md-renderer.component.html',
  styleUrls: ['./md-renderer.component.scss'],
})
export class MdRendererComponent {
  @Input()
  markdown?: string;

  public onReady(event: unknown) {
    console.log(`RendererComponent: onReady: ${JSON.stringify(event)}`);
  }
}
